module.exports = __webpack_public_path__ + "static/media/NurseF2.4f134adb.jpg";